import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

export const ACTION_PREFIX = "[Recommended Games]";
export const RECOMMENDED_GAMES_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,

	reset: `${ACTION_PREFIX} Reset ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class RecommendedGamesAction {
	getAll(): Action {
		return {
			type: RECOMMENDED_GAMES_ACTION_TYPE.getAll,
		};
	}

	getAllSuccess(recommendedGames: string[]): ActionWithPayload {
		return {
			type: RECOMMENDED_GAMES_ACTION_TYPE.getAllSuccess,
			payload: recommendedGames,
		};
	}

	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: RECOMMENDED_GAMES_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}

	reset(): Action {
		return {
			type: RECOMMENDED_GAMES_ACTION_TYPE.reset,
		};
	}
}
